import { useI18n, LANGUAGES } from "../lib/i18n";

export default function LangSwitcher({ compact = false }) {
  const { lang, setLang } = useI18n();
  return (
    <div
      data-testid="lang-switcher"
      className={`flex items-center border border-zinc-800 ${
        compact ? "" : "hidden md:flex"
      }`}
    >
      {LANGUAGES.map((l, i) => (
        <button
          key={l.code}
          data-testid={`lang-${l.code}`}
          onClick={() => setLang(l.code)}
          className={`text-[10px] uppercase tracking-widest px-3 py-2 transition-colors ${
            lang === l.code
              ? "bg-green-500 text-black font-bold"
              : "text-zinc-400 hover:text-white"
          } ${i > 0 ? "border-l border-zinc-800" : ""}`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
